import { CanDeactivateFn } from '@angular/router';
import type { ContratoGestionarComponent } from './contrato-gestionar.component';

export const contratoGestionarCanDeactivate: CanDeactivateFn<ContratoGestionarComponent> = (
  component,
) => component.confirmarSalidaSiDatosPendientes();
